/**
 * Project : workspace
 * File    : ProductCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import com.parmartechnologies.core.feature.product.model.Product
import com.parmartechnologies.ui.component.image.Image
import theme.ThemeColor

@Composable
/**
 * Executes the product card operation.
 *
 * @receiver TODO
 * @param product The product.
 * @param onClick The on click.
 * @return Unit – no return value.
 */
fun ProductCard(product: Product, onClick: (Product) -> Unit) {
    Row(
        modifier = Modifier
            .height(110.dp)
            .fillMaxWidth()
            .padding(start = 16.dp, end = 8.dp, bottom = 8.dp)
            .shadow(3.dp)
            .background(ThemeColor.shared().cardBackground)
            .zIndex(1f)
            .clickable { onClick(product) },
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier.width(80.dp)
                .height(60.dp).padding(start = 10.dp, end = 10.dp)
                .background(ThemeColor.shared().cardBackground, shape = RoundedCornerShape(30.dp))
                .clip(RoundedCornerShape(30.dp))
                .clickable { onClick(product) },
            contentAlignment = Alignment.Center
        ) {
            Image().content(product._id)
        }
        Column(modifier = Modifier.fillMaxHeight().fillMaxWidth()) {
            Text(
                text = product.Name,
                maxLines = 4,
                overflow = TextOverflow.Ellipsis,
                fontSize = 16.sp,
                fontWeight = FontWeight(400),
                modifier = Modifier
                    .fillMaxWidth()
                    .height(30.dp)
                    .padding(start = 8.dp)
            )
            Text(
                text = product.Description,
                maxLines = 4,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier
                    .fillMaxWidth()
                    .height(30.dp)
                    .padding(start = 8.dp)
            )
            Row(
                modifier = Modifier
                    .padding(start = 8.dp)
                    .width(140.dp)
                    .height(50.dp)
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Text(
                    text = "${product.ProductPrice.currency?.symbol} ${product.ProductPrice.FinalPrice}",
                    fontWeight = FontWeight(600),
                    color = ThemeColor.shared().PrimaryColor
                )
            }
        }
    }
}